import {useFeatureFlag} from 'hooks/useFeatureFlag'
import {type GetBypassQueryResponse, useGetBypass} from './useGetBypass'
import {useGetUrlAndApplicationBypass} from './useGetUrlAndApplicationBypass'

interface GetBypassPageDataQueryProps {
  policyName: string
}

// Temporary bridge while the bypass read migration rolls out. Remove this
// wrapper when #3216 deletes the legacy bypass read path after GA soak.
export const useGetBypassPageData = ({
  policyName,
}: GetBypassPageDataQueryProps): GetBypassQueryResponse => {
  const {isBypassApiMigrationEnabled} = useFeatureFlag()

  const legacyBypass = useGetBypass({
    policyName,
    enabled: !isBypassApiMigrationEnabled,
  })
  const migratedBypass = useGetUrlAndApplicationBypass({
    policyName,
    enabled: isBypassApiMigrationEnabled,
  })

  return isBypassApiMigrationEnabled ? migratedBypass : legacyBypass
}
